module.exports = __webpack_public_path__ + "img/logo-uuva-cloud-cloud.1c3e698d.png";